<template>
    <div>
        <div v-for="index in parseInt(numb)" :key="index" :class="margin">
            <v-skeleton-loader tile v-if="show" elevation="4" type="list-item-three-line"></v-skeleton-loader>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loader",
        props: {
            numb: {
                default: 3,
                type: Number | String
            },
            show: {
                default: true,
                type: Boolean
            },
            noSpace: {
                default: false,
                type: Boolean
            },
        },
        computed: {
            margin() {
                return !this.noSpace ? 'mb-3' : '';
            }
        }
    }

</script>

<style scoped>

</style>